// Pie chart color palette - vibrant colors that work on dark backgrounds
export const PIE_CHART_COLORS = [
  '#9123FF', // Purple
  '#FF1058', // Pink/Red
  '#F4B400', // Gold/Yellow
  '#00C608', // Green
  '#FF7A1A', // Orange
  '#1658FF', // Blue
];

// BCG Matrix Quadrant Definitions
export const BCG_QUADRANTS = {
  stars: {
    label: 'Stars',
    icon: '/icons/aiLessonsIcons/bcg-stars.png',
    iconBg: 'rgba(244, 180, 0, 0.2)', // Gold/Yellow
    color: 'text-yellow-400',
  },
  questionMarks: {
    label: 'Question Marks',
    icon: '/icons/aiLessonsIcons/bcg-question-marks.png',
    iconBg: 'rgba(255, 122, 26, 0.2)', // Orange
    color: 'text-orange-400',
  },
  cashCows: {
    label: 'Cash Cows',
    icon: '/icons/aiLessonsIcons/bcg-cow.png',
    iconBg: 'rgba(0, 198, 8, 0.2)', // Green
    color: 'text-green-400',
  },
  dogs: {
    label: 'Dogs',
    icon: '/icons/aiLessonsIcons/bcg-dogs.png',
    iconBg: 'rgba(255, 16, 88, 0.2)', // Pink/Red
    color: 'text-pink-400',
  },
};

// Unified Text Sizes for Slide Components
export const SLIDE_TITLE_SIZE = 'xl' as const; 
export const SLIDE_TEXT_SIZE = 'lg' as const;
// Non-text components (charts, BCG labels) use smaller fonts
export const SLIDE_COMPONENT_TITLE_SIZE = 'sm' as const;
export const SLIDE_COMPONENT_TEXT_SIZE = 'xs' as const;

// 20 motivational phrases for completion
export const COMPLETION_PHRASES = [
  "Congrats on finishing your first lesson, you\'re cooking! 🔥",
  "Amazing work! You\'re one step closer to mastery 💪",
  "Lesson complete! You\'re building real knowledge 📚",
  "Well done! Your investing skills are leveling up 📈",
  "Fantastic! You\'re making serious progress 🚀",
  "Impressive! Keep that momentum going ⚡",
  "You crushed it! Ready for more? 💎",
  "Lesson mastered! You\'re on fire 🔥",
  "Outstanding! Your future self will thank you 🌟",
  "Brilliant! You\'re becoming an expert investor 🎯",
  "Excellent work! Knowledge unlocked 🔓",
  "You nailed it! Another win in the books ✅",
  "Superb! Your dedication is paying off 💰",
  "Awesome! You\'re unstoppable now 💥",
  "Great job! Every lesson brings you closer 🎓",
  "Phenomenal! You\'re investing in yourself 🌱",
  "Incredible! Keep building that expertise 🏗️",
  "Victory! You\'re mastering the markets 🏆",
  "Stellar! Your knowledge is compounding 📊",
  "Perfect! You\'re ready for the next challenge 🎪",
];

export const FINAL_COMPLETION_PHRASES = [
  (stockName: string) =>
    `Great job! You did it. Now you\'re ready to start trading ${stockName}. 🚀`,
];
